import React, { useRef } from 'react'
import FileStructure from '../Components/FileStructure'
import HamBurg from '../Extra/HamBurg'
import styled from 'styled-components'
import MyselfHead from '../Components/MyselfHead'
import MyselfMain from '../Components/MyselfMain'
import { motion, useScroll, useTransform } from 'framer-motion'
import Contact from './Contact'

const Myself = () => {

  const container = useRef(null)

  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start end", "end start"]
  })

  const height = useTransform(scrollYProgress, [0, 0.79], ['20vh', '0vh'])
  const opacity = useTransform(scrollYProgress, [0, 0.79], [0.5, 1])

  return (
    <FileStructure>
      <HamBurg />

      <MyselfDiv ref={container}>
        <MyselfHead />
        <MyselfMain />

        <motion.div
          style={{ height,opacity }}
          className="circleContainer">
          <div className="circleMy"></div>
        </motion.div>
        <Contact />
      </MyselfDiv>
    </FileStructure>
  )
}

export default Myself

const MyselfDiv = styled.div`
    min-height: 100vh;
    background: var(--blackLight);
`